import script from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=8b763e2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b763e2c"]])

export default __exports__